import http from "../http-common";

const getAll = () => {
    return http.get("/v1/company");
};

const get = id => {
    return http.get(`/v1/company/${id}`);
};

const create = data => {
    return http.post("/v1/company", data);
};

const update = (id, data) => {
    return http.put(`/v1/company/${id}`, data);
};

const remove = id => {
    return http.delete(`/v1/company/${id}`);
};

const removeAll = () => {
    return http.delete(`/v1/company`);
};

const findByName = name => {
    return http.get(`/v1/company?name=${name}`);
};

export default {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
    findByName
};